import {z} from 'zod';

import {PaymentTypeSchema} from '@dms/api/shared';

export const TransferReceiveNoteFormSchema = z.object({
  sourceBranchId: z.string(),
  warehouseId: z.string(),
  authorizationProfileId: z.string(),
  receiveNoteNumber: z.string().nullish(),
  invoiceIssueDate: z.date().nullish(),
  deliveryNoteNumber: z.string().nullish(),
  deliveryNoteIssuedAt: z.date().nullish(),
  paymentType: PaymentTypeSchema,
  note: z.string().nullish(),
});

export type TransferReceiveNoteForm = z.infer<typeof TransferReceiveNoteFormSchema>;
